<!--
 * @Descripttion:
 * @version: 1.0
 * @Author: qiye
 * @Date: 2019-09-29 17:13:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2019-10-31 15:29:03
 -->
<template>
  <div>
    <div class="footer-wrap">
      <div class="footer">
        <div class="footer-top">
          <div class="list flex">
           <!--  <div class="bordertop"></div> -->
            <div class="flex divcenter">
              <div class="flex divdlwh">
                <dl>
                <dt>产品中心</dt>
                <a href="/cn/information" target="_blank">
                  <dd>信息发布系统</dd>
                </a>
                <a href="/cn/touchquery" target="_blank">
                  <dd>触摸查询系统</dd>
                </a>
                <a href="/cn/CloudShelf" target="_blank">
                  <dd>新零售云货架</dd>
                </a>
                <a href="/cn/office" target="_blank">
                  <dd>AI人脸识别</dd>
                </a>
                <a href="/cn/selfhelp" target="_blank">
                  <dd>自助点餐系统</dd>
                </a>
              </dl>
              <dl>
                <dt>智能硬件</dt>
                <a href="/cn/hardware/223" target="_blank">
                  <dd>信息发布系列</dd>
                </a>
                <a href="/cn/hardware/262" target="_blank">
                  <dd>触摸查询系列</dd>
                </a>
                <a href="/cn/hardware/263" target="_blank">
                  <dd>AI人脸识别系列</dd>
                </a>
                <a href="/cn/hardware/201" target="_blank">
                  <dd>自助新零售系列</dd>
                </a>
                <a href="/cn/selfhelp" target="_blank">
                  <dd>自助点餐机</dd>
                </a>
              </dl>
              <dl>
                <dt>解决方案</dt>
                <a href="/cn/solution" target="_blank">
                  <dd>智能数字显示</dd>
                </a>
                <a href="/cn/SXTouch" target="_blank">
                  <dd>商显触摸查询</dd>
                </a>
                <a href="/cn/shangxian" target="_blank">
                  <dd>AI商显服务</dd>
                </a>
                <a href="/cn/CloudShelf" target="_blank">
                  <dd>新零售行业</dd>
                </a>
                <a href="/cn/IntelligentMeeting" target="_blank">
                  <dd>智能会议</dd>
                </a>

                <a href="/cn/program" target="_blank">
                  <dd>查看更多</dd>
                </a>
              </dl>
              <dl>
                <dt>关于云标</dt>
                <a href="/cn/about" target="_blank">
                  <dd>公司介绍</dd>
                </a>
                <a href="/cn/news" target="_blank">
                  <dd>新闻资讯</dd>
                </a>
                <a href="/cn/caseshow" target="_blank">
                  <dd>应用案例</dd>
                </a>
                <!--  -->
                <a
                  href="http://pht.zoosnet.net/LR/Chatpre.aspx?id=PHT48630383&lng=cn"
                  target="_blank"
                >
                  <dd>联系我们</dd>
                </a>
              </dl>
              </div>
              <dl style="margin-right:0rem;width:1rem;margin-left:-0.5rem;white-space:normal;" class="text-center w153">
                <dt>
                  <img src="@/assets/img/qrcode.jpg" alt />
                </dt>
                <dd>
                  <p style="font-size:12px;">扫一扫获得更多动态</p>
                </dd>
              </dl>
              <dl class="footer-right" style="margin-right:0rem;">
                <dt>
                  <h2>全国热线</h2>
                </dt>
                <dd>
                  <h2>400-168-1191</h2>
                </dd>
                <dd>
                  <a href="http://pht.zoosnet.net/LR/Chatpre.aspx?id=PHT48630383&lng=cn" target="_blank">免费试用</a>
                  <a href="/cn/product" target="_blank">查看更多</a>
                </dd>
              </dl>
            </div>
          </div>
        </div>

        <div class="footer-bottom">
          <div class="detail">
            <div class="info">
              <p>
                地址：北京市海淀区信息路甲28号科实大厦B座10D
                <a
                  href="https://map.baidu.com/poi/%E4%BA%91%E6%A0%87%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12950485,4848484,13z?uid=3976a502cffe8f5cc5effb97&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&querytype=detailConInfo&da_src=shareurl"
                target="_blank">地图</a>
              </p>
              <p v-if="url[2] == 'www.yunbiao.tv'">©2015-2021 yunbiao.tv 版权所有  <a  style="color:white;" href='http://beian.miit.gov.cn' target='_blank'>京ICP备号17018905号-1</a>
               </p>
              <p v-if="url[2] !== 'www.yunbiao.tv'">©2015-2021 yunbiaowulian.tv 版权所有  <a  style="color:white;" href='http://beian.miit.gov.cn' target='_blank'>京ICP备17018905号-3</a>
               </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
		return{
      url:''
		}
	},
  mounted() {
    let url = window.location.href;
    this.url = url.split('/')
    console.log(this.url[2])
  },
}
</script>
<style lang="stylus" scoped>
.divdlwh{
  width 5.216rem
}
.footer-wrap {
  background: #363636;
  white-space: nowrap;
  color: #fff;
  padding-top: 1%;

  .list {
    /* margin-left: 1.4rem; */

    .bordertop {
      height: 1px;
      width: 5.416rem;
      left: 1.328rem;
      background: #e0e3e9;
      position: absolute;
    }

    dl {
      margin-top: 0.125rem;
      font-weight: 600;
      letter-spacing: 2px;
      &:not(:last-child){
        width 1.3rem
      }
      &:nth-child(4) {
        margin-right: 0%;
      }

      dt {
        margin-bottom: 8px;
        font-size: 17px;
        line-height 1.5
        font-weight 600
        letter-spacing: 2px;

        img {
          width: 70%;
        }
      }

      dd {
        letter-spacing: 2px;
        line-height: 28px;
        font-weight 300
        color: #eee;
        font-size: 14px;
      }
    }
  }

  .footer-right {
    margin-left: 10px;
    h2 {
      font-size: 0.15625rem;
    }

    dd:nth-child(2) {
      margin-bottom: 0.25rem;
    }

    a {
      padding: 4px 8px;
      border-radius: 10px;

      &:nth-child(1) {
        border: 1px solid #1aa3c4;
        color: #1aa3c4;

        &:hover {
          background-color: #1aa3c4;
          color: #fff;
        }
      }

      &:nth-child(2) {
        margin-left: 1.25%;
        color: #ff4500;
        border: 1px solid #ff4500;

        &:hover {
          background-color: #ff4500;
          color: #fff;
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    font-size: 14px;
    padding-bottom: 0.5%;

    .info {
      margin-top: 2%;

      a {
        color: #337ab7;
      }

      p {
        line-height 1.5
        font-size: 14px;

        &:nth-child(2) {
          margin-bottom: 0%;
        }
      }
    }
  }
}
.divcenter{
  margin 0 auto
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue